export const interestPostedDisplayNames = {
    DAILY: 'Daily',
    MONTHLY: 'Monthly',
    WEEKLY: 'Weekly',
    BI_MONTHLY: 'Bi Monthly',
    QUARTERLY: 'Quarterly',
    SEMI_ANNUALLY: 'Semi Annually',
    ANNUALLY: 'Annually',
    END_OF_WEEK: 'End Of Week',
    END_OF_MONTH: 'End Of Month',
    END_OF_QUARTER: 'End Of Quarter',
    END_OF_HALF_YEAR: 'End Of Half Year',
    END_OF_YEAR: 'End Of Year',
    END_OF_MATURITY: 'End Of Maturity',
    START_OF_WEEK: 'Start Of Week',
    START_OF_MONTH: 'Start Of Month',
    START_OF_QUARTER: 'Start Of Quarter',
    START_OF_HALF_YEAR: 'Start Of Half Year',
    START_OF_YEAR: 'Start Of Year'
};
export const getInterestPostedDisplayName = (interestPosted) => interestPostedDisplayNames[interestPosted];
